import { inject } from '@angular/core';
import { Router, CanActivateChildFn, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPermissions = route.data?.['PERMISSION_LIST'] as string[] | undefined;

  if (!requiredPermissions?.length) {
    return true;
  }

  if (!permissionService.hasAny(requiredPermissions)) {
    const redirectPath = permissionService.getFirstAccessibleRoute();
    return router.createUrlTree([redirectPath]);
  }

  return true;
};
